module.exports = __webpack_public_path__ + "static/media/1.a2c41fc8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/檸檬馬鞭草生乳酪蛋糕/1.JPG
// module id = 234
// module chunks = 0